/**
 * @name bleskczSlice
 * @description Ořízne text na určitý počet znaků. Vychází ze stejnojmenného makra ve twigu.
 *
 * @param {string} sliceText Vstupní text.
 * @param {Number} sliceEnd Výsledný počet znaků.
 * @returns {string}
 */
export function bleskczSlice(sliceText, sliceEnd) {
    let finalText = '';

    if (sliceText.length > sliceEnd) {
        let croppedText;

        if (sliceText.includes(' ')) {
            croppedText = sliceText
                .replace(/(<([^>]+)>)/gi, '')
                .slice(0, sliceEnd + 1)
                .split(' ')
                .slice(0, -1)
                .join(' ');
        } else {
            croppedText = sliceText.replace(/(<([^>]+)>)/gi, '').slice(0, sliceEnd);
        }

        finalText += `${croppedText}…`;
    } else {
        finalText = sliceText;
    }

    return finalText;
}

/**
 * @name pad
 * @description Přidá úvodní nulu pro dvojciferné číslo.
 *
 * @param n {Number} Kladné celé číslo.
 * @returns {string|*}
 */
export function pad(n) {
    return n < 10 ? `0${n}` : n;
}
